import React from "react";

import Layout from "../components/layout";
import SEO from "../components/seo";
import bookGif from "../images/book.gif";

function AboutPage() {
  return (
    <Layout>
      <SEO keywords={[`seattle`, `map`]} title="About" />

      <section className="markdown">
        <h2>About</h2>
        <p>
          The original intent of these maps was for a small, self-printed,
          pamphlet-style book.
        </p>

        <img alt="book" src={bookGif} />
        <p>
          The idea is to use this book for impromptu tours of downtown Seattle.
          The format certainly has its limitations, but its a fun way to inject
          some trivia while walking around this great city.
        </p>
        <p>
          Why is it important to know some context about a location? Glad you
          asked!
        </p>

        <h2>The City as Art</h2>
        <p>
          The impetus to create this document comes from the idea that the city
          itself can be experienced as a massive, multidimensional,
          multigenerational form of art. The artists of this piece are the
          architects, builders, construction workers, corporations, and
          individuals who have transformed this physical space in large and
          small ways to what is presented now. Some of this work is
          collaborative, some done in isolation, much of it done without thought
          of the results in the final piece. But regardless of the intent, the
          effect is a living, breathing entity that can be appreciated as well
          as any work by DaVinci or O'Keefe, and given its size and roominess,
          the city as art can typically be enjoyed for a lot longer without
          being ushered along.
        </p>

        <p>
          Many believe that when experiencing art, context can provide a deeper,
          more enriching experience. I agree with this sentiment, which is why I
          have attempted to compile an imperfect context to aid in experiencing
          Seattle. Cities are dynamic, layered, and ever changing and evolving.
          Any attempt to document such an entity is by definition incomplete and
          out of date. This short document is obviously no exception. Thus, the
          goal here is not to attempt to be comprehensive, and result in
          failure, but to provide enough context so as to reveal more of this
          city, this artwork, to the observer and assist in facilitating an
          appreciation as in art, or maybe if we are lucky, even a transcendent
          experience.
        </p>

        <p>Ok. It's also just fun to walk around and look at stuff, right?</p>

        <h2>The City as a Joke</h2>
        <p>
          Whether you find that transcendent state or not, I've also developed a
          growing list of terrible jokes and puns to use while walking about
          Seattle that you might enjoy. The intent is to incur as much groaning
          as possible.
        </p>
        <p>For example, when approaching the library one might say:</p>
        <blockquote>
          As we come up to the Seattle public library, you’ll note that it has
          quite an unusual look, but please, don’t judge a book by its cover.
        </blockquote>
        <p>
          Or when walking by the Seattle Art Museum and viewing the outside art
          installation, one could quip:
        </p>
        <blockquote>
          The Hammering Man weighs over 10,000 kilos. And, as he shows us,
          that's a lot of pounds!
        </blockquote>
        <p>
          Or what about this classic for the Fish Mongerors at Pike Place
          Market:
        </p>
        <blockquote>
          And people ask, “why do they throw the fish?” Well it's mostly so they
          can trout their wares. But sometimes they throw them just for the
          halibut. And you know, I’ve never seen them drop a fish, yes they
          never flounder.
        </blockquote>
        <p>
          Of course these are the best ones, but I'm trying to come up with
          worse and worse jokes all the time. Join me on a wander around Seattle
          and I'll tell them to you!
        </p>
      </section>
    </Layout>
  );
}

export default AboutPage;
